module.exports = __webpack_public_path__ + "static/media/tj.719b17ff.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tj.svg
// module id = 2225
// module chunks = 0